module.exports = __webpack_public_path__ + "img/339.06631462.jpg";